import lazyPage from '@monorepo/core/hoc/lazyPage'

export default () => ({
  path: '/contacts',
  component: lazyPage(() =>
    import('App/View/Contacts').then(({ Contacts }) => Contacts)
  ),
  exact: true,
})
